import $ from 'jquery';
import confetti from 'canvas-confetti';
import { apiCall } from '../aiservice/aiservice';
import { TourService } from "../../services/tourService";

interface TourStep {
    element: JQuery<HTMLElement>;
    header: string;
    body: string | number | null;
    svgsource: string | null;
    simulateClick: boolean;
    clickNext: boolean;
    nextSelector: string | null;
}

export interface TourData {
  tourId: string;
  cookieName: string;
  welcomeTitle: string;
  welcomeMessage: string;
  welcomeBtn: string;
  successTitle: string;
  successMessage: string;
  abortMessage: string;
  isFixedPosition: boolean;
  userNeedsToBeLoggedIn: boolean;
  tourSteps: TourStep[];
}

// 0 = Per session
// 0.015, = 20 minutes
const timingSettings = {
  dismiss: 0, // PerSession, 
  exitTour: 1, // 1 day
  completeTour: 365, // 1 year
  dontShowAgain: Infinity,
};

function getRelativePosition(elementId) {
  const element = document.getElementById(elementId);
  if (!element) {
      return null;
  }

  const rect = element.getBoundingClientRect();
  const docWidth = document.documentElement.clientWidth;
  const docHeight = document.documentElement.clientHeight;

  const origin = {
      x: (rect.left + rect.width / 2) / docWidth,
      y: (rect.top + rect.height / 2) / docHeight
  };

  return origin;
}

export class Tour {
  tourService: TourService;

  private currentStep: number;
  private tourData: TourData;
  private previousStepHtml: string;

  constructor(tourData: TourData) {
    this.currentStep = 0;
    this.tourData = tourData;
      this.previousStepHtml = '';
      this.tourService = new TourService();
  }

  public static createTour(tourData: TourData): Tour {
      const tour = new Tour(tourData);

      const searchField = document.getElementById('headersearch');
      const tourVisibility = searchField?.dataset?.tourvisibility === "true";

      if (!tourVisibility) {
          return tour;
      }

      if (tourData.userNeedsToBeLoggedIn) {
          apiCall("/api/user/1.0/isuserloggedin", "GET")
          .then((userIsLoggedIn: boolean) => {
              try {
                  if (userIsLoggedIn) {
                      tour.showTourWelcomeMessage();
                  }else{
                    return;
                  }
              }catch(e){
                  console.error(e);
              }
          })
          .catch(error => console.error(error));

      } else {
          tour.showTourWelcomeMessage();
      }

      return tour;

  }

  private showTourWelcomeMessage(): void {
    const tourId = this.tourData.tourId;
    //console.log("tourId: " + tourId);

    // only show feature for desktop
    if (!!window && window.innerWidth > 960) {

        this.tourService.getTourForUser(
            tourId,
            (data) => {
                data = JSON.parse(data);
                
                 if (data.IsCompleted || data.IsRejected) {
                    return;
                }

                if (data.IsShutDown) {
                    if (data.ShutDownDate) {
                        const shutDownDate = new Date(data.ShutDownDate);
                        const now = new Date();
                        shutDownDate.setDate(shutDownDate.getDate() + 1);  // Add 1 day to ShutDownDate

                        if (shutDownDate > now) {
                            return;
                        }
                    }
                }

                this.showWelcomeMessage();

            },
            (error) => {

                if (error.status === 404) {
                    this.showWelcomeMessage();
                }
            }
        );
    }
  }

    private initTour(): void {
        try {
            // start twith hiding possibly conflicting elements from the tour:
            // Hide the AI
            $("#aibox").fadeOut("slow");

            // clear the welcome message
            $(".tour-tooltip").remove();
            // show next step
            this.showMask(() => this.showStep(this.currentStep));
        } catch (error) {
            console.error('Error initializing tour:', error);
        }
    }

    private spawnConfetti() {
        const confettiOrigin = getRelativePosition('confetti');
        confetti({
            particleCount: 40,
            spread: 90,
            origin: confettiOrigin,
            zIndex: 2100,
            startVelocity: 30,
            drift: 0.2,
            disableForReducedMotion: true,
            colors: [
            '#50cdbb',
            '#710666',
            '#293d47',
            '#ffe200',
            '#7B5CA3',
            ]
        });
    }

    private showMask(callback: () => void): void {
        $('#header').append(`
            <div class="tour-mask">
            <svg>
                <defs>
                <mask id="tour-mask">
                    <rect x="0" y="0" width="100vw" height="100vh" fill="white"></rect>
                    <rect id="tour-mask-hole" x="0" y="0" width="0" height="0" rx="5" ry="5" fill="black"></rect>
                </mask>
                </defs>
                <rect x="0" y="0" width="100%" height="100%" fill="rgba(0, 0, 0, 0.5)" mask="url(#tour-mask)"></rect>
            </svg>
            </div>
        `);
        callback();
    }

    private hideMask(): void {
        $(".tour-mask").remove();
    }

    private showWelcomeMessage(): void {
        try {
            const tourId = this.tourData.tourId;

            this.tourService.started(
                tourId,
                (data) => {},
                (error) => {}
            );

            const { welcomeMessage, welcomeTitle, welcomeBtn } = this.tourData;

            const welcomeHtml = `
                <div class="tour-tooltip">
                    <button id="ignoreTour" class="closeIcon" aria-label="stäng"></button>
                    <div id="confetti"/>
                    <div class="tooltip__header">
                    <div class="imgwrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22l5.9-2Z" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                    <span>${welcomeTitle}</span>
                    </div>
                    <p>${welcomeMessage}</p>
                    <div class="tooltip__bottom">
                    <div class="left">
                        <button id="startTourBtn" class="genericBtn primary">${welcomeBtn}</button>
                    </div>
                    <div class="right">
                        <div class="checkboxcontainer" >
                        <label for="rememberChoice">Visa inte igen</label>
                        <input type="checkbox" id="rememberChoice" tabIndex="-1">
                        <span class="checkmark" tabindex="0"></span>
                        </div>
                    </div>
                </div>
            `;

            $('#header').append($(welcomeHtml).hide().fadeIn("slow"));

            const firstStep = this.tourData.tourSteps[0];
            this.positionTooltip(firstStep.element, this.tourData.isFixedPosition);

            this.attachTooltipClickEvents();

        } catch (error) {
            console.error('Error showing welcome message:', error);
        }
    }

    private showFinish(): void {
        try {
            const tourId = this.tourData.tourId;

            this.tourService.completed(
                tourId,
                (data) => {},
                (error) => {}
            );

            const { successMessage, successTitle } = this.tourData;

            const finishHtml = `
            <div class="tour-tooltip hideArrow">
                <button class="closeIcon abortBtn" aria-label="stäng"></button>
                <div id="confetti"/>
                <div class="tooltip__header">
                <div class="imgwrapper">🎉</div>
                <span>${successTitle}</span>
                </div>
                <p>${successMessage}</p>
                <div class="tooltip__bottom">
                <div class="left">
                </div>
                <div class="right">
                    <button class="genericBtn primary abortBtn">Stäng</button>
                </div>
            </div>
            `;
           $('#header').append($(finishHtml).hide().fadeIn("slow"));

            const lastStep = this.tourData.tourSteps[this.tourData.tourSteps.length - 1];
            this.positionTooltip(lastStep.element, this.tourData.isFixedPosition);

            $('#tour-mask-hole').hide();

            // // Clean up previous event listeners
            this.attachTooltipClickEvents();

            // for the last step, spawn confetti
            this.spawnConfetti();

        } catch (error) {
            console.error('Error showing step:', error);
        }
    }

    private showStep(stepIndex: number): void {
        try {
            if (stepIndex < 0 || stepIndex >= this.tourData.tourSteps.length) {
            throw new Error('Invalid step index');
            }

            const step = this.tourData.tourSteps[stepIndex];
            if (step.element === undefined) {
            throw new Error('Element for step:' + stepIndex + ' not found!');
            }

            this.highlightElement(step.element);

            const tooltipHtml = `
            <div class="tour-tooltip">
                <button class="closeIcon closeBtn" aria-label="stäng"></button>
                <div class="tooltip__header">
                ${step.svgsource !== null ? `<div class="imgwrapper">${step.svgsource}</div>` : ''}
                <span>${step.header}</span>
                </div>
                <p>${step.body ?? ''}</p>
          
                <div class="tooltip__bottom">
                <div class="left">
                    <span>${this.currentStep + 1}/${this.tourData.tourSteps?.length}</span>
                </div>
                <div class="right">
                    ${this.currentStep > 0 ? `<button id="prevBtn" class="genericBtn primary">Föregående</button>` : ''}
              
                    ${this.currentStep + 1 === this.tourData.tourSteps?.length ? `
                    <button id="finishBtn" class="genericBtn primary">Slutför</button>
                    ` : `<button id="nextBtn" class="genericBtn primary">Nästa</button>`}
                </div>
                </div>
            </div>
            `;
            $('#header').append($(tooltipHtml).hide().fadeIn("slow"));

            this.positionTooltip(step.element, this.tourData.isFixedPosition);

            // Clean up previous event listeners
            this.attachTooltipClickEvents();

        } catch (error) {
            console.error('Error showing step:', error);
        }
    }

    private highlightElement(element: JQuery<HTMLElement>): void {
        const updateHighlightPosition = () => {
            let offset, width, height;

            if (this.tourData.isFixedPosition) {
                // If the element is fixed, use offset relative to the viewport
                const rect = element[0].getBoundingClientRect();
                offset = { top: rect.top, left: rect.left };
            } else {
                // If the element is not fixed, use the offset relative to the document
                offset = element.offset();
            }

            if (!offset) return;

            width = element.outerWidth() ?? 0;
            height = element.outerHeight() ?? 0;

            $('#tour-mask-hole').attr({
                x: offset.left - 16, // Add some padding around the element
                y: offset.top - 16,
                width: width + 32,
                height: height + 32
            });
        };

        // Initial position update
        updateHighlightPosition();

        // Update position on scroll
        $(window).on('scroll resize', updateHighlightPosition);
    }

    private positionTooltip(element: JQuery<HTMLElement>, isFixed: boolean): void {
        const tooltip = $('.tour-tooltip');
        const elementHeight = element.innerHeight() ?? 0;

        const mainArea = document.getElementById("main");
        let mainWidth = mainArea.offsetWidth;

        const headerlogo = document.querySelector(".header__logo");
        let leftPosition = headerlogo.getBoundingClientRect().left;

        let updateTooltipPosition = () => {
            let top, left;

            if (isFixed) {
                const rect = element[0].getBoundingClientRect();
                top = rect.top + elementHeight + 10;
                left = rect.left;
            } else {
                const offset = element.offset();
                if (!offset) return;
                top = offset.top + elementHeight + 10 - $(window).scrollTop();
                left = offset.left;
            }

            let direction = "to-left";
            if ((left - leftPosition) < (mainWidth / 2)) {
                direction = "to-right";
            }

            tooltip.removeClass("to-left to-right").addClass(direction);

            if (element.closest('header').length) {
                tooltip.addClass('in-header');
            }

            tooltip.css({
                top: top,
                left: left
            });
        };

        updateTooltipPosition();

        // Attach scroll event to update position on scroll
        $(window).on("scroll resize", () => {
            requestAnimationFrame(updateTooltipPosition);
        });

    }

    private handleNextStep(currentStep: TourStep): void {

        if (currentStep.simulateClick) {
            currentStep.element.click();
            currentStep.element.attr("aria-pressed", "true");
      
        }
        if (currentStep.clickNext && currentStep.nextSelector) {
            const nextElement = document.querySelector(currentStep.nextSelector) as HTMLElement;
            if (nextElement) {
                nextElement.click();
            }
        }
        this.waitForElement(() => this.nextStep(), currentStep.element);
    }

    private waitForElement(callback: () => void, previousElement: JQuery<HTMLElement>, retries = 3): void {
        const nextStep = this.tourData.tourSteps[this.currentStep + 1];
        if (!nextStep) {
            callback();
            return;
        }

        const isElementVisible = nextStep.element.is(':visible');
        if (isElementVisible) {
            callback();
        } else if (retries > 0) {
            setTimeout(() => {
            this.waitForElement(callback, previousElement, retries - 1);
            }, 500);
        } else {
            console.error('Error: Next step element is not visible');
        }
    }

    private prevStep(): void {
        try {
            $(".tour-tooltip").remove();
            if (this.currentStep > 0) {
            this.currentStep--;
            this.showStep(this.currentStep);
            }
        } catch (error) {
            console.error('Error showing previous step:', error);
        }
    }

    private nextStep(): void {
        try {
            $(".tour-tooltip").remove();
            if (this.currentStep < this.tourData.tourSteps.length - 1) {
                this.currentStep++;
                this.showStep(this.currentStep);

            } else {
                this.completeTour();
            }
        } catch (error) {
            console.error('Error showing next step:', error);
        }
    }

    private finishTour(): void {
        try {
        
            $('.tour-tooltip').remove();
            this.showFinish();

        } catch (error) {
            console.error('Error closing tour:', error);
        }
    }

    private ignoreTour(): void {
        try {
            const rememberChoiceElement = $("#rememberChoice") as JQuery<HTMLInputElement>;
            const rememberChoice = rememberChoiceElement[0]?.checked;
            const tourId = this.tourData.tourId;

            if(rememberChoice){
                this.tourService.rejected(
                    tourId,
                    (data) => { },
                    (error) => { }
                );
            } else{
                this.tourService.shutdown(
                    tourId,
                    (data) => { },
                    (error) => { }
                );
            }

            $('.tour-tooltip').remove();
            this.hideMask();

        } catch (error) {
            console.error('Error ignoring tour:', error);
        }
    }

    private showCloseTourDialogue():void {
        try {
            const { abortMessage } = this.tourData;

            this.previousStepHtml = $('.tour-tooltip').html();

            const dialogueHtml = `
                <div>
                <p>${abortMessage}</p>
                <div class="tooltip__bottom">
                    <div class="left">
                    <button class="genericBtn primary abortBtn">Ja, stäng!</button>
                    </div>
                    <div class="right">
                    <button id="resetToPrevious" class="genericBtn primary">Nej, fortsätt!</button>
                    </div>
                </div>
                </div>
            `;

            $('.tour-tooltip').html(dialogueHtml);

            this.attachTooltipClickEvents();

        } catch (error) {
            console.error('Error closing tour:', error);
        }
    }

    private closeTour(): void {
        const tourId = this.tourData.tourId;

        try {
            // reset hidden conflicting elements
            $("#aibox").fadeIn("slow");

            this.tourService.getTourForUser(
                tourId,
                (data) => {
                    data = JSON.parse(data);

                    if (!data.IsCompleted) {
                        this.tourService.shutdown(
                            tourId,
                            (data) => { },
                            (error) => { }
                        );
                    }

                },
                (error) => {}
            );

            $('.tour-tooltip').remove();
            this.resetTour();
            this.hideMask();
        } catch (error) {
            console.error('Error closing tour:', error);
        }
    }

    private friendlyClose():void{
        if(this.currentStep === 0){
            this.ignoreTour();
        } else {
            this.showCloseTourDialogue();
        }
    }

  private completeTour(): void {
    try {
      
      $('.tour-tooltip').remove();
      this.hideMask();
    } catch (error) {
      console.error('Error completing tour:', error);
    }
  }

  private resetTour(): void {
    this.currentStep = 0;
    this.tourData.tourSteps.forEach(step => {
      step.element.css('border', 'none');
    });
  }

  private attachTooltipClickEvents(): void {
    const step = this.tourData.tourSteps[this.currentStep];
    $(".tour-mask").off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    $(".tour-tooltip").off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    $('#startTourBtn').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.initTour();
    });
    $('#prevBtn').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.prevStep();
    });
    $('#nextBtn').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleNextStep(step);
    });
    $('#finishBtn').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.finishTour();
    });
    $("#ignoreTour").off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.ignoreTour();
    });
    $('.closeBtn').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.showCloseTourDialogue();
    });
    $('.abortBtn').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closeTour();
    });
    $('#resetToPrevious').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $('.tour-tooltip').html(this.previousStepHtml);
      this.attachTooltipClickEvents();
    });
    $('.checkmark').on('keyup', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if(e.key === "Enter"){
        $(e.target).trigger("click");
      }
    });
    $('.tour-mask').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.friendlyClose();
    });
    $('.checkboxcontainer').off('click').on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const checkMark = $(e.currentTarget).find("input");
      const isChecked = checkMark[0].checked;
      checkMark[0].checked = !isChecked;
    });
  }
}
